window.onload = function() {
  const params = new URLSearchParams(window.location.search);
  const brand = params.get('brand');
  const brand_image = params.get('image');
  const flag = params.get('flag');
  const esp = params.get('esp');
  const img = document.getElementById("brand_image");
  img.src = "https://cdn.shopify.com/s/files/1/0282/1351/0230/files/"+brand_image+".png";
  const img_flag = document.getElementById("flag_image");
  img_flag.src = "https://cdn.shopify.com/s/files/1/0282/1351/0230/files/"+flag+".jpg";
  document.getElementById("esp").textContent = esp;
  document.getElementById("marca").textContent = "Richiedi un preventivo privato su un prodotto di marca: "+brand;
  //console.log(params);
  /*const input_marca = document.getElementById("custom#marca");
  input_marca.value=brand;
  input_marca.readonly = true;
  console.log(params);*/
}